import { useMemo } from 'react';
import { Card } from 'ui-components/components/card/card';
import { Text, TextType } from 'ui-components/components/text';
import { FlexColumn } from 'ui-components/components/flex';

import { useAdvancedShippingNoticeContext } from '../../advanced-shipping-notice-context';
import { nextSteps } from './steps';
import { SubmittedAsnStatuses } from '../../../../constants';
import { messages } from './messages';
import styles from './almost-done-card.module.less';

const OrderedListStep = ({ title, children }) => {
  return (
    <li className={styles['list-item']}>
      <FlexColumn className={styles['list-item-inner']}>
        {title}
        {children}
      </FlexColumn>
    </li>
  );
};

export const AlmostDoneCard = () => {
  const { currentAsnStatus, savedPayloads } = useAdvancedShippingNoticeContext();
  const orderedSteps = useMemo(() => nextSteps.filter((step) => step.shouldRender(savedPayloads)), [savedPayloads]);

  if (!SubmittedAsnStatuses[currentAsnStatus]) {
    return null;
  }

  return (
    <Card>
      <div className={styles['ordered-list-wrapper']}>
        <Text textType={TextType.H3} value={messages.almostDoneTitle} />
        <ol className={styles['ordered-list']}>
          {orderedSteps.map((step, index) => (
            <OrderedListStep key={index} title={step.title}>
              {step.children}
            </OrderedListStep>
          ))}
        </ol>
      </div>
    </Card>
  );
};
